<!-- Misma carcasa que el alta pública de candidato (`kf-page--public`): las dos
     son la misma cosa vista desde los dos lados del producto, y hasta hoy no se
     parecían en nada — una tenía barra negra y todo centrado, y la otra tarjetas
     numeradas sobre crema. Quien llega desde `/access/companies` y desde
     `/access/candidates` tiene que reconocer que está en el mismo sitio. -->
<div class="kf-page kf-page--public">

	@if (!done()) {
		<header class="kf-public-head">
			<div class="kf-public-head__inner">
				<span class="kf-public-head__brand">
					<img class="kf-public-head__logo" src="assets/layout/images/branding/km-monogram.png" alt="" />
					<img
						class="kf-public-head__word"
						src="assets/layout/images/branding/kairos-merit-wordmark-black.png"
						alt="Kairos Merit" />
				</span>
				<div class="kf-public-head__text">
					<h1>{{ 'publicForms.companySignup.title' | transloco }}</h1>
					<p>{{ 'publicForms.companySignup.intro' | transloco }}</p>
				</div>
			</div>
		</header>
	}

	<div class="kf-public-body">

	@if (done()) {
		<!-- Acuse de recibo, no un aviso que se desvanece: aquí se dice a qué
		     dirección hay que ir a mirar, y esa frase tiene que quedarse en
		     pantalla. -->
		<section class="kf-thanks" role="status">
			<span class="kf-thanks__check" aria-hidden="true"><i class="pi pi-envelope"></i></span>
			<h1>{{ 'publicForms.companySignup.success.title' | transloco }}</h1>
			<p>{{ 'publicForms.companySignup.success.message' | transloco: { email: sentTo() } }}</p>
			<p class="kf-thanks__hint">{{ 'publicForms.companySignup.success.hint' | transloco }}</p>
			<a class="qs-btn qs-btn--primary" routerLink="/access/companies">
				{{ 'publicForms.companySignup.success.back' | transloco }}
			</a>
		</section>
	} @else {
		<form class="kf-form" [formGroup]="form" (submit)="$event.preventDefault(); submit()" novalidate>

			<!-- Qué incluye. Va SIN número: los números de este formulario cuentan
			     los pasos que hay que rellenar, y esto no se rellena, se lee. -->
			<section class="qs-card">
				<header class="qs-head">
					<span class="qs-index qs-index--icon" aria-hidden="true"><i class="pi pi-gift"></i></span>
					<div class="qs-headings">
						<h2 class="qs-title">{{ 'publicForms.companySignup.perks.title' | transloco }}</h2>
						<p class="qs-hint">{{ 'publicForms.companySignup.subtitle' | transloco }}</p>
					</div>
				</header>
				<ul class="cs-perks">
					<li>{{ 'publicForms.companySignup.perks.vacancies' | transloco }}</li>
					<li>{{ 'publicForms.companySignup.perks.applications' | transloco }}</li>
					<li>{{ 'publicForms.companySignup.perks.anonymous' | transloco }}</li>
					<li>{{ 'publicForms.companySignup.perks.upgrade' | transloco }}</li>
				</ul>
			</section>

			<section class="qs-card">
				<header class="qs-head">
					<span class="qs-index">01</span>
					<div class="qs-headings">
						<h2 class="qs-title">{{ 'publicForms.companySignup.sections.company' | transloco }}</h2>
						<p class="qs-hint">{{ 'publicForms.companySignup.sectionHints.company' | transloco }}</p>
					</div>
				</header>

				<!-- Recuperar lo escrito sin decirlo parecería cosa de magia, y quien no
				     recuerde haber empezado tiene derecho a saber por qué hay datos suyos
				     en la pantalla. -->
				@if (draftResumed()) {
					<div class="qs-alert qs-alert--info" role="status">
						<i class="pi pi-history" aria-hidden="true"></i>
						<span>{{ 'publicForms.companySignup.draft.resumed' | transloco }}</span>
					</div>
				}

				<div class="qs-grid">
					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-companyName">
							{{ 'publicForms.companySignup.fields.companyName' | transloco }}<span class="qs-req">*</span>
						</label>
						<input
							id="cs-companyName"
							type="text"
							class="qs-input"
							[class.is-invalid]="invalid('companyName')"
							formControlName="companyName"
							autocomplete="organization" />
						@if (invalid('companyName')) {
							<small class="qs-err">{{ 'publicForms.companySignup.errors.required' | transloco }}</small>
						}
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-contactName">
							{{ 'publicForms.companySignup.fields.contactName' | transloco }}<span class="qs-req">*</span>
						</label>
						<input
							id="cs-contactName"
							type="text"
							class="qs-input"
							[class.is-invalid]="invalid('contactName')"
							formControlName="contactName"
							autocomplete="name" />
						@if (invalid('contactName')) {
							<small class="qs-err">{{ 'publicForms.companySignup.errors.required' | transloco }}</small>
						}
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-email">
							{{ 'publicForms.companySignup.fields.email' | transloco }}<span class="qs-req">*</span>
						</label>
						<input
							id="cs-email"
							type="email"
							class="qs-input"
							[class.is-invalid]="invalid('email')"
							formControlName="email"
							autocomplete="email"
							inputmode="email" />
						@if (invalid('email')) {
							<!-- Vacío y mal escrito no son el mismo error: "escribe un email
							     válido" sobre un campo en blanco no dice qué falta. -->
							<small class="qs-err">
								{{
									(form.controls.email.hasError('required')
										? 'publicForms.companySignup.errors.required'
										: 'publicForms.companySignup.errors.email'
									) | transloco
								}}
							</small>
						}
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-phone">
							{{ 'publicForms.companySignup.fields.phone' | transloco }}<span class="qs-req">*</span>
						</label>
						<input
							id="cs-phone"
							type="tel"
							class="qs-input"
							[class.is-invalid]="invalid('phone')"
							formControlName="phone"
							autocomplete="tel"
							inputmode="tel"
							placeholder="+971 50 123 4567" />
						@if (invalid('phone')) {
							<!-- Vacío y mal escrito no son el mismo error: al que se dejó en
							     blanco hay que decirle que falta, y al que puso un número
							     local, que sin prefijo de país no se le puede llamar. -->
							<small class="qs-err">
								{{
									(form.controls.phone.hasError('required')
										? 'publicForms.companySignup.errors.required'
										: 'publicForms.companySignup.errors.phone'
									) | transloco
								}}
							</small>
						} @else {
							<small class="qs-hint">{{ 'publicForms.companySignup.fields.phoneHint' | transloco }}</small>
						}
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-position">
							{{ 'publicForms.companySignup.fields.position' | transloco }}<span class="qs-req">*</span>
						</label>
						<input
							id="cs-position"
							type="text"
							class="qs-input"
							[class.is-invalid]="invalid('position')"
							formControlName="position"
							autocomplete="organization-title" />
						@if (invalid('position')) {
							<small class="qs-err">{{ 'publicForms.companySignup.errors.required' | transloco }}</small>
						}
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-city">
							{{ 'publicForms.companySignup.fields.city' | transloco }}
						</label>
						<input
							id="cs-city"
							type="text"
							class="qs-input"
							formControlName="city"
							autocomplete="address-level2" />
					</div>

					<div class="qs-field qs-col-6">
						<label class="qs-label" for="cs-website">
							{{ 'publicForms.companySignup.fields.website' | transloco }}
						</label>
						<input
							id="cs-website"
							type="url"
							class="qs-input"
							formControlName="website"
							autocomplete="url"
							placeholder="https://" />
						<small class="qs-hint">{{ 'publicForms.companySignup.fields.websiteHint' | transloco }}</small>
					</div>

					<div class="qs-field qs-col-6">
						<span class="qs-label">{{ 'publicForms.companySignup.fields.propertyType' | transloco }}</span>
						<app-select
							formControlName="propertyType"
							[options]="propertyTypeOptions"
							[placeholder]="'common.placeholders.select' | transloco"
							[appendTo]="null"
							size="medium"></app-select>
					</div>

					<!-- Logo o imagen de la propiedad (08/09): opcional. Se sube al
					     elegirlo y el alta guarda la ruta. -->
					<div class="qs-field qs-col-12">
						<span class="qs-label">{{ 'publicForms.companySignup.fields.logo' | transloco }}</span>
						<div class="cs-logo">
							@if (logoPreview(); as preview) {
								<img class="cs-logo__img" [src]="preview" alt="" />
							} @else {
								<span class="cs-logo__empty" aria-hidden="true">
									<i class="pi pi-image" aria-hidden="true"></i>
								</span>
							}
							<div class="cs-logo__body">
								<label class="cs-logo__btn" [class.is-busy]="logoBusy()">
									{{
										(logoBusy()
											? 'publicForms.companySignup.fields.logoUploading'
											: logoPreview()
												? 'publicForms.companySignup.fields.logoChange'
												: 'publicForms.companySignup.fields.logoUpload'
										) | transloco
									}}
									<input type="file" accept="image/png,image/jpeg,image/webp" hidden [disabled]="logoBusy()" (change)="onLogoPicked($event)" />
								</label>
								@if (logoPreview()) {
									<button type="button" class="cs-logo__remove" (click)="removeLogo()">
										{{ 'publicForms.companySignup.fields.logoRemove' | transloco }}
									</button>
								}
								<small class="qs-hint">{{ 'publicForms.companySignup.fields.logoHint' | transloco }}</small>
								@if (logoError(); as error) {
									<small class="qs-error">{{ 'publicForms.companySignup.fields.logoError.' + error | transloco }}</small>
								}
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="qs-card">
				<header class="qs-head">
					<span class="qs-index">02</span>
					<div class="qs-headings">
						<h2 class="qs-title">{{ 'publicForms.companySignup.sections.consent' | transloco }}</h2>
						<p class="qs-hint">{{ 'publicForms.companySignup.sectionHints.consent' | transloco }}</p>
					</div>
				</header>

				<div class="cs-consent">
					<input id="cs-privacy" class="qs-check" type="checkbox" formControlName="privacy" />
					<div class="cs-consent__body">
						<label for="cs-privacy">{{ 'publicForms.companySignup.fields.privacy' | transloco }}</label>
						<!-- El consentimiento es obligatorio: tiene que poder leerse lo que
						     se acepta. Mismo aviso que ofrece el login, no una copia. -->
						<a class="cs-legal-link" href="/legal" target="_blank" rel="noopener">
							{{ 'auth.legal.link' | transloco }}
						</a>
						@if (invalid('privacy')) {
							<small class="qs-err">{{ 'publicForms.companySignup.errors.privacy' | transloco }}</small>
						}
						<!-- Consentir a escondidas no es consentir: aquí se dice que aceptar es
						     también lo que autoriza a guardar lo escrito y a escribir un
						     recordatorio. Antes de marcarla no sale del navegador ni un campo. -->
						<small class="qs-hint">{{ 'publicForms.companySignup.draft.consentHint' | transloco }}</small>
					</div>
				</div>
			</section>

			@if (serverError()) {
				<div class="qs-alert" role="alert">
					<i class="pi pi-exclamation-circle" aria-hidden="true"></i>
					<span>{{ 'publicForms.companySignup.errors.' + serverError() | transloco }}</span>
				</div>
			}

			<div class="qs-actionbar">
				<span class="qs-actionbar__note">
					{{ 'publicForms.companySignup.noCard' | transloco }}
					@if (draftSavedAt(); as savedAt) {
						· {{ 'publicForms.companySignup.draft.saved' | transloco: { time: savedAt | date: 'shortTime' } }}
					}
				</span>
				<div class="qs-actionbar__buttons">
					<button
						type="submit"
						class="qs-btn qs-btn--primary"
						[attr.aria-busy]="submitting() ? 'true' : null"
						[disabled]="submitting()">
						{{
							(submitting() ? 'publicForms.companySignup.submitting' : 'publicForms.companySignup.submit')
								| transloco
						}}
					</button>
				</div>
			</div>
		</form>
	}

	</div>

</div>
